import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CommonService } from 'src/app/core/services/common.service';
import { SubSink } from 'subsink';
import { LaunchDarklyService } from 'src/app/core/services/launchdarkly.service';
import { FEATURE_FLAGS } from 'src/app/shared/launchdarkly.constants';
import { LDFlagValue } from 'launchdarkly-js-client-sdk';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  @Input('title') title: string = '';
  @Input('type') type: string = 'button';
  @Input('color') color: 'default' | 'blue' = 'default';
  @Input('style') style: 'primary' | 'secondary' = 'primary';
  @Input('disabled') disabled: boolean = false;
  @Input('isDropdown') isDropdown: boolean = false;
  @Input('ariaLabel') ariaLabel: string = '';
  @Input('loadingTrigger') loadingTrigger: Subject<boolean> =
    new Subject<boolean>();
  @Output('onClick') onClick = new EventEmitter();
  loading: boolean = false;
  subsink: SubSink = new SubSink();
  
  // Feature flag for accessibility
  enableDataTableAccessibility$!: Observable<LDFlagValue>;
  enableDataTableAccessibilityValue: boolean = false;

  constructor(
    private commonService:CommonService,
    private readonly ldService: LaunchDarklyService
  ) {}

  ngOnInit(): void {
    // Initialize feature flag observable
    this.enableDataTableAccessibility$ = this.ldService.getFlagValue(
      FEATURE_FLAGS.ENABLE_DATA_TABLE_ACCESSIBILITY,
      false
    );
    
    // Subscribe to get synchronous value for logic
    this.subsink.add(
      this.enableDataTableAccessibility$.subscribe((value) => {
        this.enableDataTableAccessibilityValue = !!value;
      })
    );
    
    this.subsink.add(
    this.loadingTrigger.subscribe((v) => {
      this.loading = v;
    }));
  }

  get isOpenGovTheme() {
    return !this.commonService.isIgnatiusThemeApplied;
  }

  click = () => {
    this.onClick.emit();
  };

  get accessibleLabel(): string {
    // Only use accessible label when feature flag is ON
    if (this.enableDataTableAccessibilityValue) {
      return this.ariaLabel || this.title;
    }
    return '';
  }

  get btnBGColor() {
    if (this.style === 'secondary') return '#fff';
    switch (this.color) {
      case 'blue':
        return 'var(--button-primary-blue)';
      case 'default':
      default:
        return 'var(--button-primary-background)';
    }
  }

  get btnColor() {
    if (this.style === 'secondary') return 'var(--button-secondary-foreground)';
    switch (this.color) {
      case 'default':
      default:
        return 'white';
    }
  }

  get btnOutline() {
    if (this.style === 'primary') return 'none';
    switch (this.color) {
      case 'default':
      default:
        return '1px solid var(--call-to-action-primary-action-dark)';
    }
  }

  ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }
}
